export default function AdaptiveImages({ data }: { data: string }) {
  return (
    <>
      <source
        srcSet={`${data}-mobile.webp, ${data}-mobile-2x.webp 2x`}
        type="image/webp"
        media="(max-width: 767px)"
      />
      <source
        srcSet={` ${data}-mobile.png, ${data}-mobile-2x.png 2x`}
        type="image/png"
        media="(max-width: 767px)"
      />
      <source srcSet={`${data}.webp, ${data}-2x.webp 2x`} type="image/webp" />
      <source srcSet={`${data}.png, ${data}-2x.png 2x`} type="image/png" />
    </>
  );
}
